import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
  type RouteRecordRaw,
} from "vue-router";

import { useAuthStore } from "@/stores/auth";

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/dashboard" },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
    meta: { public: true },
  },
  {
    path: "/auth/callback",
    name: "auth-callback",
    component: () => import("@/views/AuthCallbackView.vue"),
    meta: { public: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/DashboardView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/jobs/new",
    name: "job-new",
    component: () => import("@/views/JobNewView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
  },
  {
    path: "/jobs/:jobId",
    name: "job-detail",
    component: () => import("@/views/JobDetailView.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/jobs/:jobId/import",
    name: "job-import",
    component: () => import("@/views/ImportView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
    props: true,
  },
  {
    path: "/teams",
    name: "teams",
    component: () => import("@/views/TeamsView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
  },
  {
    path: "/teams/:teamId",
    name: "team-detail",
    component: () => import("@/views/TeamDetailView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
    props: true,
  },
  {
    path: "/jobs/:jobId/batches/:batchId",
    name: "batch-detail",
    component: () => import("@/views/BatchDetailView.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/scheduler",
    name: "scheduler",
    component: () => import("@/views/SchedulerView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/views/ReportsView.vue"),
    meta: { requiresAuth: true, requiresCoordinator: true },
  },
];

export const router = createRouter({
  // History mode required so Keycloak can redirect to /auth/callback?code=…
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to: RouteLocationNormalized) => {
  const auth = useAuthStore();

  if (to.meta.public) {
    if (to.name === "login" && auth.isAuthenticated) {
      return { name: "dashboard" };
    }
    return true;
  }

  if (!auth.isAuthenticated) {
    await auth.hydrate();
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: "login", query: { next: to.fullPath } };
  }

  if (to.meta.requiresCoordinator && !auth.isCoordinator) {
    return { name: "dashboard" };
  }

  return true;
});
